import { apiEndPoints, apiMethods } from '../../../../../../utils/apiConstants'
import customAxios from '../../../../../../utils/customAxios'

export const fetchMyWalletThunk = async () => {
	try {
		const responseJson = await customAxios[apiMethods.get](apiEndPoints?.getWalletDetails)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchCreditDebitThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.creditDebitListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchfundsReceivedHistoryThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.fundsReceivedHistoryListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchfundsTransferHistoryThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.fundsTransferHistoryListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
export const fetchfundTransferThunk = async (body) => {
	try {
		const responseJson = await customAxios[apiMethods.post](apiEndPoints?.fundsTransferListing, body)
		const data = responseJson.data
		return data
	} catch (error) {
		throw error
	}
}
